<div class="card shadow-sm mb-4">
  <div class="card-body p-4">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
      <div>
        <h5 class="mb-1 fw-bold">Designations</h5>
        <span class="sub-text">Manage employee designations</span>
      </div>
      <button class="btn btn-primary d-flex align-items-center gap-2" (click)="onAddDesignation()">
        <i class="bi bi-plus-lg"></i>
        Add Designation
      </button>
    </div>

    @if (isDataLoading) {
      <app-loading-spinner></app-loading-spinner>
    } @else {
      @if (designations.length === 0) {
        <app-info-alert>No designations found. Add your first designation to get started.</app-info-alert>
      } @else {
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0">
            <thead class="bg-light">
              <tr>
                <th class="border-0 text-uppercase small fw-bold text-muted py-3">Title</th>
                <th class="border-0 text-uppercase small fw-bold text-muted py-3 text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (designation of designations; track designation.id) {
                <tr>
                  <td class="py-3">
                    <div class="fw-semibold">{{ designation.title }}</div>
                  </td>
                  <td class="py-3 text-end">
                    <div class="d-flex gap-2 justify-content-end">
                      <button
                        class="btn btn-action-edit btn-sm"
                        (click)="onEditDesignation(designation)"
                        title="Edit designation">
                        <i class="bi bi-pencil-square"></i>
                      </button>
                      <button
                        class="btn btn-action-delete btn-sm"
                        (click)="onDeleteDesignation(designation)"
                        title="Delete designation">
                        <i class="bi bi-trash3"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }
  </div>
</div>

<ng-template #designationModal let-modal>
  <div class="modal-content border-0 shadow-lg">
    <form [formGroup]="designationForm" (ngSubmit)="onSubmit()">
      <div class="modal-header py-3">
        <h5 class="modal-title">{{ isEditMode ? 'Edit Designation' : 'Add Designation' }}</h5>
        <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
      </div>

      <div class="modal-body p-4">
        @if (formError) {
          <app-error-alert [error]="formError" />
        }

        <div class="mb-3">
          <label class="form-label small fw-bold text-muted">
            Title
            <span class="text-danger">*</span>
          </label>
          <input type="text" class="form-control" formControlName="title" placeholder="e.g. Sales Officer" />
          @if (isInvalid('title')) {
            <div class="text-danger small mt-1">Title is required and must be at least 2 characters.</div>
          }
        </div>
      </div>

      <div class="modal-footer border-0">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
        <button type="submit" class="btn btn-primary" [disabled]="designationForm.invalid || isSaving">
          @if (isSaving) {
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Saving...
          } @else {
            {{ isEditMode ? 'Update' : 'Create' }}
          }
        </button>
      </div>
    </form>
  </div>
</ng-template>
